import { Typography, useEventCallback } from '@mui/material';
import FilterIcaro from 'civil-status/components/research-icaro/filter';
import TableDeclarations from 'civil-status/components/research-icaro/table';
import { IcaroResearchCrumbs } from 'civil-status/constants/breadcrumb';
import { transformerDeclarationsList } from 'civil-status/utils/transformer-declarations-list';
import { transformerDeclarationsListFilter } from 'civil-status/utils/transformer-declarations-list-filter';
import {
  DeclarationsListVM,
  FilterResearchFormIcaro,
  ResearchFormIcaro,
} from 'civil-status/view-models/research-form-icaro';
import { Fragment, ReactElement, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbItem } from 'shell/components/shared/breadcrumb';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { HttpResponseList } from 'shell/models/http-response';
import { SearchDeclaration } from 'shell/models/search-declaration';

const ActResearchIcaroPage = (): ReactElement => {
  const params = useParams();

  const [openFilterAct, setOpenFilterAct] = useState<boolean>(true);
  const [openFilterPerson, setOpenFilterPerson] = useState<boolean>(true);

  const [filterSelected, setFilterSelected] = useState<FilterResearchFormIcaro>({});
  const [tableProps, setTableProps] = useState<Record<string, number>>({
    page: 0,
    rowsPerPage: 10,
  });

  // const filterTable = useFilterTable<ResearchFormIcaro>();

  const [declarationsList, getDeclarationsList] = useHttpFetch<
    HttpResponseList<SearchDeclaration>,
    Array<DeclarationsListVM>
  >(`${__ACT_API_URL__}/ricerca-dichiarazione-nascita`, {
    onBootstrap: false,
    options: {
      errorCatching: true,
      method: 'POST',
      loading: true,
      data: {},
    },
    transformer: transformerDeclarationsList,
  });

  const getDeclarationsListData = useEventCallback((dataFilter: FilterResearchFormIcaro) => {
    (
      getDeclarationsList({
        data: dataFilter,
      }) as unknown as ResponsePromise<void>
    ).then(() => {
      // salvo i filtri dell'ultima ricerca
      setFilterSelected(dataFilter);
    });
  });

  const handleSubmit = useEventCallback((values?: ResearchFormIcaro) => {
    const dataFilter: FilterResearchFormIcaro = {
      ...transformerDeclarationsListFilter(values),
      pageOffset: 0,
      pageSize: 10,
    };

    setTableProps({
      page: 0,
      rowsPerPage: 10,
    });
    getDeclarationsListData(dataFilter);
  });

  useEffect(() => {
    if (((declarationsList.data as Array<DeclarationsListVM>) || []).length) {
      // se abbiamo risultato chiudere accordion dei filtri
      setOpenFilterAct(false);
      setOpenFilterPerson(false);
    }
  }, [declarationsList.data]);

  const itemsBreadcrubs: Array<BreadcrumbItem> = useMemo(() => {
    return IcaroResearchCrumbs(params.valueCat || '', params.idCat || '');
  }, [params.valueCat, params.idCat]);

  return (
    <Fragment>
      <Breadcrumbs items={itemsBreadcrubs} />
      <div className="pmi-pt-4 pmi-pb-3 pmi-d-flex pmi-align-items-center pmi-justify-content-between">
        <Typography
          color="secondary.main"
          style={{
            fontSize: '26px',
          }}
        >
          Ricerca Icaro
        </Typography>
      </div>
      <div className="circle" />
      <FilterIcaro
        setOpenFilterAct={setOpenFilterAct}
        setOpenFilterPerson={setOpenFilterPerson}
        openFilterAct={openFilterAct}
        openFilterPerson={openFilterPerson}
        handleSubmitAct={handleSubmit}
        handleSubmitPerson={handleSubmit}
      />
      {declarationsList.data ? (
        ((declarationsList.data as Array<DeclarationsListVM>) || [])?.length > 0 ? (
          <>
            <TableDeclarations
              data={declarationsList.data as Array<DeclarationsListVM>}
              filterSelected={filterSelected}
              getDeclarationsListData={getDeclarationsListData}
              tableProps={tableProps}
              setTableProps={setTableProps}
              valueCat={params.valueCat || ''}
              idCat={params.idCat || ''}
            />
          </>
        ) : (
          <Typography color="secondary.main">
            Nessun elemento trovato con la ricerca effettuata.
          </Typography>
        )
      ) : undefined}
    </Fragment>
  );
};

ActResearchIcaroPage.displayName = 'Research Icaro Page component';

export default ActResearchIcaroPage;
